

import { DataGrid } from "components/DataGrid/DataGrid";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";

import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toast } from "components/ToastShow/ToastAlert";
import { downloadCSV, getPageSize, trans } from "utils/helpers";
import { deleteForm, getAllForms } from "../../api";
import { DynamicFormData } from "./DynamicFormData";
import { useLocation, useSearchParams } from "react-router-dom";
import { MessageType } from "types/enum";


interface Form {
    Title?: string,
    Status?: number
}
export const DynamicFormsPage = ({ }: Form) => {
    const [response, setResponse] = useState<Response | any>(null);
    const [selectedObj, setSelectedObj] = useState<any>(null);
    const [mode, setMode] = useState("create");
    const [forceUpdate, setForceUpdate] = useState(false);
    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
          const [pageNum, setPageNum] = useState<any>(1);
      const [pageSize, setPageSize] = useState<number>(25);
      const [pages, setPages] = useState<number>(0);
    const [showEventForm , setShowEventForm] = useState(false)
    const [menuData,setMenuData]=useState<any>(null)
  const location = useLocation() as any;
  const [searchParams,setSearchParams]=useSearchParams()
//   const queryParams = new URLSearchParams(location.search);
  const SystemKey = searchParams.get("systemKey");
    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "excel":downloadCSV(response,1 ,trans("DynamicForms"));break;
            case "refresh": setForceUpdate(!forceUpdate); break;
            case "create": handleCreateAction(); break;
            case "view": if (selectedObj?.Id) handleViewRow(); break;
            case "edit": if (selectedObj?.Id) handleEditRow(); break;
            // case "remove": if (selectedObj?.Id) Toast(trans("msg_deleteconfirm"), "warning" , "alert" , handleDeleteRow); break;
            case "remove": if (selectedObj?.Id) Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete , handleDeleteRow); break;

            case "help": alert("call api help"); break;
        }
    };
    const handleCreateAction = () => {
        setMode("create")
        setShowEventForm(true)
    }
    const handleEditRow = () => {
        setMode("edit");
        setShowEventForm(true)
    }

    const handleViewRow = () => {
        setMode("view")
        setShowEventForm(true)
    }

    const handleDeleteRow =async () => {
        try {
            await deleteForm(selectedObj?.FormKey)
            setForceUpdate(!forceUpdate)
        } catch (error) {
            
        }

    }

    const cansel = ()=>{
        setShowEventForm(false)
        setForceUpdate(!forceUpdate)
    }

    const selectedObjCallback = (obj, index) => {
        setSelectedObj(obj);
    }

      async function getFormsAsync(pagNum = pageNum) {
        setLoading(false)
        setResponse(null)
        try {
              let pageSizeChangedByUser = getPageSize("dataCollection")
        setPageSize(pageSizeChangedByUser)
            const res = await getAllForms(pagNum, pageSizeChangedByUser);
         if (res.Data.TotalRecords > 0) {
        setResponse(res.Data);
        setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) ;

      }
            setMessageType("info")
        } catch (error) {
            setMessageType("error")
        }
        setLoading(true)
    }
      const handleChangePageSize = (e: any) => {
            setPageNum(1);
            setPageSize(e.currentTarget.value);
            getPageSize("dataCollection", e.currentTarget.value)
            getFormsAsync(1);
        };
        const handleGoPage = (value) => {
            if (value) {
                setPageNum(+value);
                getFormsAsync(+value);
            } else {
            }
        };
        const handleNextPage = () => {
            if (response.TotalRecords && ((response.TotalRecords / pageSize) > pageNum)) {
                setPageNum((pageNum) => { return +pageNum + 1 });
                getFormsAsync(pageNum + 1);
    
            }
        };
        const handlePrevPage = () => {
            if (pageNum > 1) {
                setPageNum((pageNum) => { return +pageNum - 1 });
                getFormsAsync(pageNum - 1);
            }
        };
    




    useEffect(() => {
    
         getFormsAsync();
        
    }, [forceUpdate]);

    useEffect(() => {
        if(searchParams.get('systemKey')){
            setMenuData({FormKey:searchParams.get('systemKey')})
            // setShowEventForm(true)
        }
        
    }, [searchParams.get('systemKey')]);

    return (
        <>   
        {
            menuData?.FormKey?
            <DynamicFormData formObj={menuData} />
            :
            <>
            
             {showEventForm ? <ModalForm modalHeight={50} mode={mode} onHide={()=>cansel()} show={showEventForm} title={selectedObj?.FormTitle} ><DynamicFormData formObj={selectedObj} /> </ModalForm> : null}
            <div className="cartable-action">
                <Toolbar emptyList={response?.length==0} remove={true} id={selectedObj?.Id} search={true} handleClickToolbar={clickToolbarCallback} />
                <div className="card" style={{overflowY: "auto",height: "74vh",scrollbarWidth: "thin",}}>
                    <div className="">
                        {loading ?
                            <>
                                {
                                    response?.Data?.length > 0 ?
                                        <>
                                            <DataGrid
                                                parentName={"FormsInformation"}
                                                startIndex={1}
                                                theadData={Object.keys(response.Data[0])}
                                                tbodyData={response.Data}
                                                minCellWidth={80}
                                                selectedRowObjectCallback={selectedObjCallback}
                                                handleView={handleViewRow}
                                                // handleDelete={(e)=>{Toast(trans("msg_deleteconfirm"), "warning" , "alert" ,handleDeleteRow)}}
                                                handleDelete={(e)=>{Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete ,handleDeleteRow)}}
                                                totalRecords={response.TotalRecords}
                                                pageNum={pageNum}
                                                pageSize={pageSize}
                                                HandleNextPage={handleNextPage}
                                                HandlePrevPage={handlePrevPage}
                                                handlechangePageSize={handleChangePageSize}
                                                first={() => { getFormsAsync(pages); setPageNum(pages) }}
                                                end={() => { getFormsAsync(1); setPageNum(1) }}
                                                handleGoPage={handleGoPage}

                                            />
                                        </>
                                        : <Message message={"NoDataForPreview"} type={messageType} />
                                }
                            </>
                            : <Loading />
                        }
                    </div>
                </div>
            </div>
            
            </>
        }
             
        </>

    );
}